export default "__VITE_PUBLIC_ASSET__a79f283f__"